import React from "react";
import { Box } from "@mui/material";

const BlogArticleLead = ({ html }) => {
  if (!html) {
    return null;
  }

  return (
    <Box
      sx={{
        fontSize: { xs: 20 },
        lineHeight: 1.6,
        color: "hsl(150 30% 14% / 0.9)",
        mb: 5,
        "& p": {
          m: 0,
        },
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default BlogArticleLead;
